/* eslint-disable react/no-unknown-property */
import React from 'react';
import { ICarouselSlide } from '../../../../../types';
import { PictureInPicture } from '../../../../pictureInPicture/pictureInPicture';

function CarouselSlide(props: ICarouselSlide) {
    const image = (
        <img
            className={props.className}
            alt={props.alt}
            src={props.src}
            srcSet={props.srcSet}
            key={props.slideIndex}
            fetchpriority={props.slideIndex === 0 ? 'high': undefined}
        />
    );

    return props.showPIPicons ? (
        <PictureInPicture>
            {image}
        </PictureInPicture>
    ) : image;
}

export default CarouselSlide;
